import {PublicationModel} from './publication.model';
import {UserModel} from './user.model';
export class HistoryPageAbleModel {
    totalItems: number;
    items: HistoryModel[]=[];
}

export class HistoryModel {
    id:string;
    publications:PublicationModel[]=[];
    createdBy:UserModel = new UserModel();
    /**
     *  Type 1 = Created apply
     *  Type 2 = Edited apply
     *  Type 3 = Set ISBN Automaticaly
     *  Type 4 = Set ISBN Manualy
     *  Type 5 = Accepted prints
     *  Type 6 = Deleted ISBN
     *
     *  Type 101 = Generate ISBN report
     *  Type 102 = Generate Prints
     *  Type 200 = Generate Isbn Changed report
     */
    historyType:number;
    createdDatetime:Date;
    comment:string;
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/models/historyModel.ts